import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7800e514 from 'nuxt_plugin_plugin_7800e514' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_router_863bf8ba from 'nuxt_plugin_router_863bf8ba' // Source: ./router.js (mode: 'all')
import nuxt_plugin_axios_6ba1b98c from 'nuxt_plugin_axios_6ba1b98c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_5ceec134 from 'nuxt_plugin_cookieuniversalnuxt_5ceec134' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginsrouter_1dd81dec from 'nuxt_plugin_pluginsrouter_1dd81dec' // Source: ../plugins/plugins-router (mode: 'all')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ../plugins/element-ui (mode: 'all')
import nuxt_plugin_methods_d2c08984 from 'nuxt_plugin_methods_d2c08984' // Source: ../plugins/methods (mode: 'all')
import nuxt_plugin_tracking_b906beaa from 'nuxt_plugin_tracking_b906beaa' // Source: ../plugins/tracking (mode: 'client')
import nuxt_plugin_analytics_3ba45812 from 'nuxt_plugin_analytics_3ba45812' // Source: ../plugins/analytics (mode: 'client')
import nuxt_plugin_vueqr_301d3a84 from 'nuxt_plugin_vueqr_301d3a84' // Source: ../plugins/vue-qr (mode: 'client')
import nuxt_plugin_vuexpersistedstate_1da59343 from 'nuxt_plugin_vuexpersistedstate_1da59343' // Source: ../plugins/vuex-persistedstate (mode: 'client')
import nuxt_plugin_permission_6b8185c5 from 'nuxt_plugin_permission_6b8185c5' // Source: ../plugins/permission (mode: 'client')
import nuxt_plugin_ry_5d03b786 from 'nuxt_plugin_ry_5d03b786' // Source: ../plugins/ry (mode: 'client')
import nuxt_plugin_vuequilleditor_67e94cdc from 'nuxt_plugin_vuequilleditor_67e94cdc' // Source: ../plugins/vue-quill-editor (mode: 'client')
import nuxt_plugin_compressor_745668bb from 'nuxt_plugin_compressor_745668bb' // Source: ../plugins/compressor (mode: 'client')
import nuxt_plugin_vueseamlessscroll_3fee5b46 from 'nuxt_plugin_vueseamlessscroll_3fee5b46' // Source: ../plugins/vue-seamless-scroll (mode: 'client')
import nuxt_plugin_vuelazyload_211b2937 from 'nuxt_plugin_vuelazyload_211b2937' // Source: ../plugins/vue-lazyload (mode: 'client')
import nuxt_plugin_pzDialog_15520d68 from 'nuxt_plugin_pzDialog_15520d68' // Source: ../plugins/pzDialog (mode: 'client')
import nuxt_plugin_api_1731851e from 'nuxt_plugin_api_1731851e' // Source: ../enum/api (mode: 'client')
import nuxt_plugin_uploadType_043245a4 from 'nuxt_plugin_uploadType_043245a4' // Source: ../enum/uploadType (mode: 'client')
import nuxt_plugin_repeat_3f7b4ede from 'nuxt_plugin_repeat_3f7b4ede' // Source: ../plugins/repeat (mode: 'client')
import nuxt_plugin_updatetrackid_7415232b from 'nuxt_plugin_updatetrackid_7415232b' // Source: ../plugins/update-track-id (mode: 'client')
import nuxt_plugin_trackingnew_1be0b800 from 'nuxt_plugin_trackingnew_1be0b800' // Source: ../plugins/tracking-new (mode: 'client')
import nuxt_plugin_vconsole_0d98d997 from 'nuxt_plugin_vconsole_0d98d997' // Source: ../plugins/vconsole (mode: 'client')
import nuxt_plugin_index_20b088e1 from 'nuxt_plugin_index_20b088e1' // Source: ../icons/index.js (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_elementchinaareadata_5f954643 from 'nuxt_plugin_elementchinaareadata_5f954643' // Source: ../node_modules/element-china-area-data (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"zh-CN"},"meta":[{"charset":"utf-8"},{"name":"renderer","content":"webkit"},{"name":"force-rendering","content":"webkit"},{"name":"apple-mobile-web-app-titl","content":"盼之代售"},{"name":"og:type","content":"盼之代售"},{"name":"og:title","content":"盼之代售"},{"name":"og:site_name","content":"盼之代售"},{"http-equiv":"X-UA-Compatible","content":"IE=Edge,chrome=1"},{"http-equiv":"Content-Type","content":"text\u002Fhtml; charset=utf-8"},{"name":"viewport","content":"width=device-width,initial-scale=1,user-scalable=no,viewport-fit=cover"},{"name":"referrer","content":"strict-origin-when-cross-origin"}],"link":[{"ref":"dns-prefetch","href":"\u002F\u002Fpzdsoss.pzds.com"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"src":"\u002F\u002Fo.alicdn.com\u002Ffrontend-lib\u002Fcommon-lib\u002Fjquery.min.js"},{"src":"https:\u002F\u002Fcn-shanghai-aliyun-cloudauth.oss-cn-shanghai.aliyuncs.com\u002Fweb_sdk_js\u002Fjsvm_all.js"},{"src":"https:\u002F\u002Fcdn.ronghub.com\u002FRongEmoji-2.2.10.min.js"},{"src":"https:\u002F\u002Fhm.baidu.com\u002Fhm.js?8e2c03f98f8af83cf09317d232baf903","defer":"defer"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7800e514 === 'function') {
    await nuxt_plugin_plugin_7800e514(app.context, inject)
  }

  if (typeof nuxt_plugin_router_863bf8ba === 'function') {
    await nuxt_plugin_router_863bf8ba(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_6ba1b98c === 'function') {
    await nuxt_plugin_axios_6ba1b98c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_5ceec134 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_5ceec134(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsrouter_1dd81dec === 'function') {
    await nuxt_plugin_pluginsrouter_1dd81dec(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (typeof nuxt_plugin_methods_d2c08984 === 'function') {
    await nuxt_plugin_methods_d2c08984(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tracking_b906beaa === 'function') {
    await nuxt_plugin_tracking_b906beaa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_3ba45812 === 'function') {
    await nuxt_plugin_analytics_3ba45812(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueqr_301d3a84 === 'function') {
    await nuxt_plugin_vueqr_301d3a84(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersistedstate_1da59343 === 'function') {
    await nuxt_plugin_vuexpersistedstate_1da59343(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_permission_6b8185c5 === 'function') {
    await nuxt_plugin_permission_6b8185c5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ry_5d03b786 === 'function') {
    await nuxt_plugin_ry_5d03b786(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuequilleditor_67e94cdc === 'function') {
    await nuxt_plugin_vuequilleditor_67e94cdc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_compressor_745668bb === 'function') {
    await nuxt_plugin_compressor_745668bb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueseamlessscroll_3fee5b46 === 'function') {
    await nuxt_plugin_vueseamlessscroll_3fee5b46(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_211b2937 === 'function') {
    await nuxt_plugin_vuelazyload_211b2937(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pzDialog_15520d68 === 'function') {
    await nuxt_plugin_pzDialog_15520d68(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_api_1731851e === 'function') {
    await nuxt_plugin_api_1731851e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_uploadType_043245a4 === 'function') {
    await nuxt_plugin_uploadType_043245a4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_repeat_3f7b4ede === 'function') {
    await nuxt_plugin_repeat_3f7b4ede(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_updatetrackid_7415232b === 'function') {
    await nuxt_plugin_updatetrackid_7415232b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_trackingnew_1be0b800 === 'function') {
    await nuxt_plugin_trackingnew_1be0b800(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vconsole_0d98d997 === 'function') {
    await nuxt_plugin_vconsole_0d98d997(app.context, inject)
  }

  if (typeof nuxt_plugin_index_20b088e1 === 'function') {
    await nuxt_plugin_index_20b088e1(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_elementchinaareadata_5f954643 === 'function') {
    await nuxt_plugin_elementchinaareadata_5f954643(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
